import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {PermissionsConverter} from '../../../../../../common/converter/permissions.converter';
import {PrescriptionMedicineSummaryModel} from '../prescriptionMedicineSummary.model';


@Injectable({ providedIn: 'root' })
export class PrescriptionMedicineSummaryConverter extends HttpModelConverter<PrescriptionMedicineSummaryModel> {
    constructor() {
        super();
    }
        protected  createInstance(): PrescriptionMedicineSummaryModel {
        return new PrescriptionMedicineSummaryModel();
    }

    protected enrichObject(result: PrescriptionMedicineSummaryModel, src: PrescriptionMedicineSummaryModel) {
        result.permissions = new PermissionsConverter().convert(src.permissions);
    }
}
